import ArcMarked from './ArcMarked.js';
export {ArcMarked};
window.customElements.define('arc-marked', ArcMarked);
